import React from 'react'
import styled from 'styled-components'
import useBreadcrumbs from 'use-react-router-breadcrumbs'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { _, colors } from 'utils'
import routes from 'routes'
import { BackButton } from 'components/ReusableStyledComponents'
import { TopHeader } from '../Headers'
import Icon from '../Icon'

export const S = {
    Breadcrumb: styled.div<{ shouldPushDownContent: boolean }>`
        width: 100%;
        padding: ${({ shouldPushDownContent }) => (shouldPushDownContent ? 60 : 24)}px 20px 0 20px;
        transition: padding 0.2s ease-in-out;
    `,
    Wrapper: styled.div`
        display: flex;
        align-items: center;
        & > a:last-child .nav-icon {
            display: none;
        }
    `,
    BreadcrumbHeader: styled.h1`
        margin: 0;
        font-weight: bold;
        font-size: 24px;
        line-height: 28px;
        color: ${colors.grayTitle};
    `,
    VerticalDivider: styled.div`
        width: 0;
        height: 24px;
        margin: 0 24px;
        border-left: 1px solid ${colors.fadeIcon};
    `,
    BreadcrumbItem: styled(Link)`
        line-height: 35px;
        text-decoration: none !important;
        font-size: 14px;
        color: ${colors.icon} !important;
        &:hover {
            color: ${colors.grayTitle} !important;
        }
    `,
    NavIcon: styled(Icon)`
        transform: rotate(-90deg);
        padding: 0 10px;
    `,
    NonClickBreadcrumbItem: styled.div`
        font-size: 14px;
        line-height: 35px;
        user-select: none;
    `,
}

interface Props {
    title?: string
    hasSpaceBreadcrumb?: boolean
    hasBackButton?: boolean
    shouldPushDownContent?: boolean
}

export default ({
    title, hasSpaceBreadcrumb, hasBackButton, shouldPushDownContent
}: Props) => {
    const options = {
        disableDefaults: true,
        excludePaths: hasSpaceBreadcrumb ? [] : ['/:eventSlug']
    }
    const breadcrumbs = useBreadcrumbs(
        // @ts-ignore
        Object.values(routes), options
    )
    const history = useHistory()
    const location = useLocation()
    const backPath = location.pathname.replace(/\/[^/]*$/, '')

    return (
        <S.Breadcrumb shouldPushDownContent={shouldPushDownContent}>
            {hasBackButton && (
                <BackButton onClick={() => history.push(backPath)}>
                    <Icon icon="chevronDown" />
                    {_('button.back')}
                </BackButton>
            )}
            {breadcrumbs.length > 1 ? (
                <S.Wrapper>
                    <S.BreadcrumbHeader>{_(title)}</S.BreadcrumbHeader>
                    <S.VerticalDivider />
                    {breadcrumbs.map(({ breadcrumb, match }, index) => (
                        index === breadcrumbs.length - 1 ? (
                            <S.NonClickBreadcrumbItem>
                                {/* @ts-ignore */}
                                {_(breadcrumb?.props?.children)}
                            </S.NonClickBreadcrumbItem>
                        ) : (
                            <S.BreadcrumbItem key={index} to={match.url}>
                                {/* @ts-ignore */}
                                {_(breadcrumb?.props?.children)}
                                <S.NavIcon
                                    className="nav-icon"
                                    icon="chevronDown"
                                    color={colors.fadeIcon}
                                    size={18}
                                />
                            </S.BreadcrumbItem>
                        )
                    ))}
                </S.Wrapper>
            ) : (
                <TopHeader>
                    {_(title)}
                </TopHeader>
            )}
        </S.Breadcrumb>
    )
}
